// UseQueryKeys

const useQueryKeys = {
    users: ["users"],
    leaves: ["leaves"],
    cities: ["cities"],
    countries: ["countries"],
    company: ["company"],
    roles: ["roles"],
    permissions: ["permissions"],
    category: ["category"],
    entity: ["entity"],
    events: ["events"],
    payments: ["payments"],
};

export default useQueryKeys;
